<nz-spin *ngIf="isLoading.agreement" nzSimple [nzSize]="'large'"></nz-spin>

<markdown *ngIf="!isLoading.upload" (ready)="onAgreementLoaded()" [src]="agreementFileUrl"></markdown>

<div *nzModalFooter class="cp__buttons">
  <nz-upload
    [nzAccept]="'.md'"
    [nzShowUploadList]="false"
    [nzAction]="fileUploadUrl"
    [nzHeaders]="fileUploadHeadersFn"
    (nzChange)="handleChange($event)">
    <button nz-button [nzLoading]="isLoading.upload"><i nz-icon nzType="upload"></i>{{'button.upload' | transloco}}</button>
  </nz-upload>

  <a class="agreement-download" [href]="agreementFileUrl" [download]="organization.id + '.agreement.md'">Скачать</a>

  <button (click)="modalRef.close()" nz-button nzType="default" class="justify-end">{{'button.close' | transloco}}</button>
</div>
